import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryInformation } from '@next/core-lib/cart';
import { format } from 'date-fns';

@Pipe({ name: 'formatFlexibilityDate', standalone: true })
export class FormatFlexibilityDatePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  public transform(value: DeliveryInformation): string {
    if (value?.possibleDeliveryDays) {
      if (value.possibleDeliveryDays.length > 1) {
        // Get the earliest date from the possible delivery days
        const earliestDate = value.possibleDeliveryDays.reduce((earliest, current) => {
          return new Date(current) < new Date(earliest) ? current : earliest;
        }, value.possibleDeliveryDays[0]);
        return this.datePipe.transform(new Date(earliestDate));
      } else {
        return;
      }
    }

    const deliveryDate: string = value?.deliveryDate;
    const flexibility = value?.flexibility;
    let sundayFlexibility = 0;
    if (!deliveryDate || !flexibility || flexibility <= 0) {
      return;
    } else {
      const dayInMilliseconds = 60 * 60 * 24 * 1000;
      for (let i = 1; i <= flexibility; i++) {
        if (format(new Date(deliveryDate).getTime() - i * dayInMilliseconds, 'eeee') === 'Sunday') {
          sundayFlexibility++;
        }
      }
      return this.datePipe.transform(new Date(new Date(deliveryDate).getTime() - (flexibility + sundayFlexibility) * dayInMilliseconds));
    }
  }
}
